import * as yup from 'yup';

const converterStringParaNumero = (value, valorOriginal) => {
  if (!valorOriginal && valorOriginal !== 0) {
    return undefined;
  }

  if (typeof valorOriginal === 'string') {
    const valorConvertido = valorOriginal.replace(',', '.');
    const numero = parseFloat(valorConvertido);

    if (!Number.isNaN(numero)) {
      return numero;
    }
  }

  return valorOriginal;
};

export default yup.object().shape({
  categoria:
    yup.string().required('Campo Requerido'),
  cnpj:
    yup.string().required('Campo Requerido'),
  referenciaTrust:
    yup.string(),
  classificacao:
    yup.string().required('Campo Requerido'),
  filiais:
    yup.string().required('Campo Requerido'),
  aplicacao:
    yup.string().required('Campo Requerido'),
  incoterm:
    yup.string().required('Campo Requerido'),
  freteContainer:
    yup
      .string()
      .nullable()
      .required('Campo Requerido')
      .matches(/^-?\d+(\.\d+)?$/, 'Formato inválido'),
  qtdContainers:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Campo Requerido')
      .typeError('Formato Inválido'),
  enderecoOrigem:
    yup.string().when('incoterm', {
      is: 'EXW',
      then: yup.string().required('Campo Requerido'),
    }),
  portoOrigem:
    yup.string().required('Campo Requerido'),
  portoDestino:
    yup.string().required('Campo Requerido'),
  logisticaNacional:
    yup.boolean().required('Campo Requerido'),
  enderecoEntrega:
    yup.string().required('Campo Requerido'),
  observacoes:
    yup.string(),
  solicitadoPor:
    yup.string().required(),
  status:
    yup.string().required(),
  produtos:
    yup.array(yup.object().shape({
      ncm:
        yup.string()
          .required('NCM é obrigatório.')
          .min(3, 'NCM deve ter no mínimo três caracteres.')
          .max(255),
      unidadeMedida:
        yup.string()
          .required('Unidade de medida é obrigatória.')
          .min(1, 'Unidade de medida deve ter no mínimo um caracter.')
          .max(255, 'Unidade de medida deve ter no máximo 255 caracteres.'),
      quantidade:
        yup.number()
          .required('Quantidade é obrigatória.')
          .positive(),
      valorUnitario:
        yup.number()
          .required('Valor unitário é obrigatório.')
          .min(0),
      moeda:
        yup.string().required('Moeda é obrigatória.'),
      li:
        yup.string().required('Campo Requerido'),
      ii: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .required('Campo Requerido')
        .typeError('Formato Inválido'),
      ipi: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .required('Campo Requerido')
        .typeError('Formato Inválido'),
      pis: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .required('Campo Requerido')
        .typeError('Formato Inválido'),
      cofins: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .required('Campo Requerido')
        .typeError('Formato Inválido'),
      cofinsCusto: yup
        .string()
        .nullable()
        .required('Campo Requerido'),
      icms: yup
        .string()
        .nullable()
        .required('Campo Requerido'),
      taxaTrust: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .required('Campo Requerido')
        .typeError('Formato Inválido'),
    })).required('Campo Requerido').min(1, 'O campo produtos deve ter pelo menos um item.'),
  despesasAdministrativas:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Campo Requerido')
      .typeError('Formato Inválido'),
  despesaAgenteCarga:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Campo Requerido')
      .typeError('Formato Inválido'),
  honorarioDespacho:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Campo Requerido')
      .typeError('Formato Inválido'),
  seguroInternacional:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Campo Requerido')
      .typeError('Formato Inválido'),
  acrescimos:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Campo Requerido')
      .typeError('Formato Inválido'),
  taxaMoeda:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Campo Requerido')
      .typeError('Formato Inválido'),
  adicionalIMO:
    yup
      .boolean()
      .nullable()
      .required('Campo Requerido'),
  anuenciaEmissaoLI:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Campo Requerido')
      .typeError('Formato Inválido'),
  custosOrigem:
    yup.number().when('incoterm', {
      is: 'EXW',
      then: yup
        .number()
        .nullable()
        .transform(converterStringParaNumero)
        .required('Campo Requerido')
        .typeError('Formato Inválido'),
    }),
  thdThc:
    yup
      .number()
      .nullable()
      .transform(converterStringParaNumero)
      .required('Campo Requerido')
      .typeError('Formato Inválido'),
  outrosCampos:
    yup.array(
      yup.object().shape({
        value:
          yup
            .number()
            .transform(converterStringParaNumero)
            .typeError('Formato Inválido'),
      }),
    ),
});
